<ul class="list-group" *ngFor="let site of list">
    <li class="list-group-item">
        <b>Host:</b> {{ site.host }}<br>
        <b>Név:</b> {{ site.name}}
    </li>
  </ul>
